<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_xii"></a><a id="page_xiii"></a><a id="abb"></a>Abbreviations</h2>
<p class="noindent1"><span class="small">ADD</span> – Additional Manuscripts</p>
<p class="noindent1"><span class="small">AE</span> – Paris, Ministère des Relations Extérieures</p>
<p class="noindent1"><span class="small">ANG</span> – Angleterre</p>
<p class="noindent1"><span class="small">BL</span> – London, British Library</p>
<p class="noindent1"><span class="small">CP</span> – Correspondance Politique</p>
<p class="noindent1"><span class="small">FO</span> – Foreign Office</p>
<p class="noindent1"><span class="small">LH</span> – London, King’s College, Liddell Hart Archive</p>
<p class="noindent1"><span class="small">NA</span> – London, National Archives</p>
<p class="noindent1"><span class="small">SP</span> – State Papers<a id="page_xiv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?7279458e